import React from 'react';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import moment from 'moment';
import {
	Grid,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from '@mui/material';

const PREFIX = 'RescheduleDialog';

const classes = {
    appBar: `${PREFIX}-appBar`,
    title: `${PREFIX}-title`,
    table: `${PREFIX}-table`
};

const Root = styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.appBar}`]: {
		position: 'relative',
	},

    [`& .${classes.title}`]: {
		marginLeft: theme.spacing(2),
		flex: 1,
	},

    [`& .${classes.table}`]: {
		minWidth: '250',
		minHeight: '500',
	}
}));

interface RescheduleDialogProps {
	showRescheduleModal: boolean;
	handleCloseModal: any;
	refundData: any;
}

type width = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
export default function RescheduleDialog(props: RescheduleDialogProps) {
	const { showRescheduleModal, handleCloseModal, refundData } = props;


	const handleClose = () => {
		handleCloseModal();
	};

	const [fullWidth] = React.useState(true);
	const [maxWidth] = React.useState<width>('lg');

	return (
        <Root>
			<Dialog
				fullWidth={fullWidth}
				maxWidth={maxWidth}
				open={showRescheduleModal}
				onClose={handleClose}>
				<AppBar className={classes.appBar}>
					<Toolbar>
						<IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                            size="large">
							<CloseIcon />
						</IconButton>
						<Typography variant="h6" className={classes.title}>
							Schedule Details{' '}
						</Typography>
					</Toolbar>
				</AppBar>
				<Grid container>
					<Grid item xs={2}></Grid>
					<Grid item xs={8}>
						<TableContainer component={Paper}>
							<Table className={classes.table} aria-label="simple table">
								<TableHead>
									<TableRow>
										<TableCell> Advertisement Name</TableCell>
										<TableCell align="right">Campaign Name</TableCell>
										<TableCell align="right">Client Name</TableCell>
										<TableCell align="right">Date</TableCell>
										<TableCell align="right">Budget</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									<TableCell>{refundData?.advertisementName}</TableCell>
									<TableCell align="right">
										{refundData?.campaignName}
									</TableCell>
									<TableCell align="right">
										{' '}
										{refundData?.clientName}
									</TableCell>
									<TableCell align="right">
										{moment(refundData?.requestedTs).format(
											' DD/MM/YYYY',
										)}
									</TableCell>
									<TableCell align="right">
										₹ {refundData?.amount}
									</TableCell>
								</TableBody>
							</Table>
						</TableContainer>
					</Grid>
					<Grid item xs={2}></Grid>
				</Grid>
			</Dialog>
		</Root>
    );
}
